import {
    ADD_PAGE_ALERT,
    CLEAR_PAGE_ALERT
} from '../Actions/PageAlertActions';

const initialState = {
    level: '',
    title: '',
    message: ''
};

export default function pageAlertReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_PAGE_ALERT:
            return {
                ...state,
                level: action.text.level,
                title: action.text.title,
                message: action.text.message
            }

        case CLEAR_PAGE_ALERT:
            return {
                ...state,
                level: "",
                title: "",
                message: ""
            }
        default:
            return state;
    }
}